import { render, staticRenderFns } from "./MailImage.vue?vue&type=template&id=7d74bd3e"
import script from "./MailImage.vue?vue&type=script&lang=js"
export * from "./MailImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports